import { getActiveDiagram } from '../../theme';
import { PIPELINE_GLYPH_SIZE } from '../types';
export var S = PIPELINE_GLYPH_SIZE;
export var MID = S / 2;
export function stroke() {
    return getActiveDiagram().schematicStroke;
}
export function fill() {
    return getActiveDiagram().schematicFill;
}
export function addLine(app, g, x, y, dx, dy, sw, color) {
    if (sw === void 0) { sw = 2; }
    g.add(app.line({ x: x, y: y, x2: dx, y2: dy, stroke: color !== null && color !== void 0 ? color : stroke(), strokeWidth: sw, lineCap: 'round', listening: false }));
}
/** Circle helper — `(x, y)` is the center (library Circle uses top-left). */
export function addCircle(app, g, x, y, r, fillColor, sw) {
    if (fillColor === void 0) { fillColor = null; }
    if (sw === void 0) { sw = 1.75; }
    g.add(app.circle({
        x: x - r,
        y: y - r,
        radius: r,
        fill: fillColor,
        stroke: stroke(),
        strokeWidth: sw,
        listening: false,
    }));
}
export function addText(app, g, text, x, y, size) {
    if (size === void 0) { size = 8; }
    g.add(app.text({
        text: text,
        x: x,
        y: y,
        fontSize: size,
        fontWeight: '700',
        fontFamily: getActiveDiagram().fontFamily,
        fill: stroke(),
        listening: false,
    }));
}
export function addBox(app, g, x, y, w, h, labelOrRadius) {
    var radius = typeof labelOrRadius === 'number' ? labelOrRadius : 4;
    var label = typeof labelOrRadius === 'string' ? labelOrRadius : undefined;
    g.add(app.roundedRect({
        x: x,
        y: y,
        width: w,
        height: h,
        cornerRadius: radius,
        fill: fill(),
        stroke: stroke(),
        strokeWidth: 1.75,
        listening: false,
    }));
    if (label) {
        var approx = label.length * 4.2;
        addText(app, g, label, x + Math.max(2, (w - approx) / 2), y + h / 2 + 3, 8);
    }
}
export function addPoly(app, g, points, sw, fillColor) {
    if (sw === void 0) { sw = 2.1; }
    if (fillColor === void 0) { fillColor = null; }
    g.add(app.polygon({
        points: points,
        fill: fillColor,
        stroke: stroke(),
        strokeWidth: sw,
        listening: false,
    }));
}
export function addEllipse(app, g, x, y, radiusX, radiusY, fillColor, sw) {
    if (fillColor === void 0) { fillColor = null; }
    if (sw === void 0) { sw = 1.75; }
    g.add(app.ellipse({
        x: x - radiusX,
        y: y - radiusY,
        radiusX: radiusX,
        radiusY: radiusY,
        fill: fillColor,
        stroke: stroke(),
        strokeWidth: sw,
        listening: false,
    }));
}
/* ── Shared family drawers (local 48×48 coords) ─────────────────────────── */
